import { ILog, ILogFilters, RecentActivity } from "@/types/log.type";
import {
  IPaginationProps,
  IPaginationResponse,
  RealISort
} from "@/types/rtk.type";
import { buildQueryParams } from "@/utils/rtk";
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../query";
import { Tag } from "../tag";

// TODO: Refactor - double check response + fix TS error
export const logApi = createApi({
  reducerPath: "logQuery",
  baseQuery: apiBaseQuery,
  tagTypes: [Tag.RECENT_ACTIVITY, Tag.RECENT_ACTIVITY_LIST],
  endpoints: (builder) => ({
    getLogs: builder.query<
      IPaginationResponse<ILog> | ILog[],
      (IPaginationProps & ILogFilters & RealISort) | void
    >({
      query: (params) => `/portal_logs/list?${buildQueryParams(params || {})}`
    }),

    getRecentActivities: builder.query<RecentActivity[], void>({
      query: () => `/portal_logs/recent_activities`,
      providesTags: (result) => {
        return result
          ? [
              { type: Tag.RECENT_ACTIVITY_LIST },
              ...result.map(({ id }) => ({ type: Tag.RECENT_ACTIVITY, id }))
            ]
          : [{ type: Tag.RECENT_ACTIVITY_LIST }];
      }
    })
  })
});

export const { useGetLogsQuery, useGetRecentActivitiesQuery } = logApi;
